module.exports = __webpack_public_path__ + "img/logo-color.b6b41af8.svg";